module.exports = __webpack_public_path__ + "img/benefit1.03773c14.png";